<template>
  <div class="about-us view-conten">
    <!-- 关于我们的banner -->
    <div class="about-us-banner">
      <div class="banner-title">
        <div class="banner-title-cn">关于我们</div>
        <div class="banner-title-en">About Us</div>
      </div>
      <img src="@/assets/aboutUs/banner4.jpg" alt="" />
    </div>
    <!-- 内容区域 -->
    <div class="about-us-content">
      <!-- 公共标题 -->
      <topTitle num="01" cnName="公司介绍" enName="Company Introduction" />
      <!-- 公司介绍 -->
      <div class="about-us-introduction">
        <div>
          智数魔方（上海）软件有限公司（简称“智数魔方”）始
          创于2013年，坐落于繁华的浦东陆家嘴软件园，在北
          京、上海、深圳、台北、青岛设立营销中心，并在全国
          30多个省市设立服务机构。
          智数魔方自联袂IBM和易正低代码平台以来，持续深耕
          SRM、财务管理及低/无代码平台开发与服务，能够为用
          户提供量身定制的解决方案。团队依托全球领先的技术生
          态和行业洞察力，提供从咨询到系统落地的全流程服务，
          助力客户在智能化时代赢得“成本领先、市场敏捷、创新
          可持续”的竞争优势。
          目前，产品已远销欧美日等发达国家和地区，为众多企业
          提供长期优质服务。客户包括：万向集团、中广电器、亮兮柯、康迪克、亿太诺、奥普家居、康恩贝、大金空
          调、张小泉、A一二三、华域、民生保险、银轮股份、
          茵梦达、海联金汇、国茂、安然集团、恒力电机、永
          兴特钢、索菲码等全球行业领军企业。
        </div>
        <div>
          公司愿景：成为企业智慧供应链与卓越财务运营的首
          选伙伴。通过数字化解决方案，助力企业实现精细化
          运营和战略转型，为客户创造长期价值，实现可持续
          发展。
        </div>
      </div>
      <!-- 实施内容 暂时隐藏-->
      <div class="active-card-wrap" v-show="false">
        <div class="active-card">
          <div class="card-title deepblue">实施服务</div>
          <div class="card-content">
            通过成熟的项目管理方法指引，并由PMO在项目进度、项目质量、资源协调等方面进行监管，保证成功交付通过成熟的项目管理方法指引。
          </div>
        </div>
        <div class="active-card">
          <div class="card-title orange">实施服务</div>
          <div class="card-content">
            通过成熟的项目管理方法指引，并由PMO在项目进度、项目质量
          </div>
        </div>
        <div class="active-card">
          <div class="card-title blue">实施服务</div>
          <div class="card-content">
            通过成熟的项目管理方法指引，并由PMO在项目进度、项目质量、资源协调等方面进行监管，保证成功交付通过成熟的项目管理方法指引.资源协调等方面进行监管，保证成功交付通过成熟的项目管理方法指引。
          </div>
        </div>
      </div>
      <!-- 联系我们标题 -->
      <div class="bottom-title">联系我们</div>
      <!-- 公司选择 -->
      <div class="companys">
        <div :class="['companys-item', index === selectIndex ? 'active' : '']" v-for="(item, index) in companyData"
          :key="item.id" @click="handleCompany(index)">
          {{ item.name }}
        </div>
      </div>
      <!-- 展示数据 -->
      <div class="company-content">
        <div class="company-info">
          <div class="company-info-item">
            地址：{{ companyDetail[selectIndex].address }}
          </div>
          <div class="company-info-item">
            邮编：{{ companyDetail[selectIndex].postcode }}
          </div>
          <div class="company-info-item" v-if="companyDetail[selectIndex].phone">
            电话：{{ companyDetail[selectIndex].phone }}
          </div>
          <div class="company-info-item" v-if="companyDetail[selectIndex].fax">
            传真：{{ companyDetail[selectIndex].fax }}
          </div>
          <!-- <div class="company-info-item">
            邮箱：{{ companyDetail[selectIndex].email }}
          </div> -->
        </div>
        <div class="company-img">
          <img :src="companyDetail[selectIndex].img" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import topTitle from '../components/top-title'
import shnaghai from '@/assets/aboutUs/shnaghai.png'
import hangzhou from '@/assets/aboutUs/hangzhou.jpeg'
import nanjing from '@/assets/aboutUs/nanjing.jpg'
import wuxi from '@/assets/aboutUs/wuxi.jpg'

export default {
  components: { topTitle },
  data () {
    return {
      selectIndex: 0,
      companyData: [
        { id: 1001, name: '上海总公司' },
        { id: 1002, name: '南京分公司' },
        { id: 1003, name: '无锡分公司' },
        { id: 1004, name: '杭州分公司' }
      ],
      companyDetail: [
        {
          address: '上海市浦东新区峨山路91弄28号陆家嘴软件园3号楼五楼',
          postcode: '200127',
          phone: '021-58768609',
          fax: '021-58768609',
          email: 'mark.wang@esbpm.com',
          img: shnaghai
        },
        {
          address: '南京市鼓楼区建宁路65号金川科技园21栋',
          postcode: '210000',
          // phone: '025-85201303',
          // fax: '025-85201303',
          email: 'mark.wang@esbpm.com',
          img: nanjing
        },
        {
          address: '江苏省无锡市梁溪区动力工厂七楼',
          postcode: '214026',
          // phone: '0510-81807636',
          // fax: '0510-81807636',
          email: 'mark.wang@esbpm.com',
          img: wuxi
        },
        {
          address: '浙江省杭州市萧山区宁围街道萧山农业大厦1幢27楼',
          postcode: '310000',
          // phone: '021-58768609',
          // fax: '021-58768609',
          email: 'mark.wang@esbpm.com',
          img: hangzhou
        }
      ]
    }
  },
  methods: {
    handleCompany (index) {
      this.selectIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
.about-us {
  width: 100%;

  .about-us-banner {
    position: relative;

    .banner-title {
      color: #ffffff;
      position: absolute;
      width: 1200px;
      margin: 0 auto;
      top: 121px;
      left: 0;
      right: 0;

      .banner-title-cn {
        font-size: 48px;
        font-weight: bold;
      }

      .banner-title-en {
        margin-top: 10px;
        width: 108px;
        font-size: 24px;
        padding-bottom: 13px;
        border-bottom: 10px solid #0990ff;
      }
    }

    img {
      width: 100%;
      height: 400px;
    }
  }

  .about-us-content {
    margin: 0 auto;
    width: 1200px;

    .about-us-introduction {
      font-size: 16px;
      color: #666666;
      margin-top: 30px;
      line-height: 28px;
      text-indent: 2em;
      margin-bottom: 50px;
    }

    .active-card-wrap {
      display: flex;
      margin-bottom: 94px;

      .active-card {
        width: 384px;
        height: 328px;
        border: 1px solid #dddddd;

        .deepblue {
          background: #4681ef;
        }

        .orange {
          background: #e29755;
        }

        .blue {
          background: #47c3e6;
        }

        .card-title {
          height: 68px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 24px;
          color: #fff;
        }

        .card-content {
          color: #666666;
          font-size: 18px;
          // height: calc(100% - 68px);
          padding: 24px;
          line-height: 30px;
        }
      }

      .active-card:nth-child(2) {
        margin-left: 24px;
        margin-right: 24px;
      }
    }

    .bottom-title {
      text-align: center;
      font-size: 32px;
      color: #333333;
      font-weight: bold;
      margin-bottom: 52px;
    }

    .companys {
      display: flex;
      width: 100%;
      background: #f4fafe;
      border: 1px solid #dddddd;
      height: 72px;
      color: #666666;

      .companys-item {
        width: 300px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-size: 20px;

        &:hover {
          color: #0c55dd;
        }
      }

      .active {
        background: #0c55dd;
        color: #fff;

        &:hover {
          color: #fff;
        }
      }
    }

    .company-content {
      margin-top: 16px;
      margin-bottom: 70px;
      height: 385px;
      background: #f4fafe;
      border: 1px solid #dddddd;
      display: flex;

      .company-info {
        padding-top: 14px;
        padding-left: 16px;
        width: 603px;

        .company-info-item {
          margin-top: 32px;
        }
      }

      .company-img {
        width: 601px;
        height: 385px;

        img {
          height: 100%;
          width: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/aboutUs.vue